import styled from 'styled-components';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';

export const InsuranceLine = styled(StyledRow)`
  margin: 0;
  padding: 0.55rem 12px;
  align-items: flex-start;
  flex-wrap: wrap;
  background-color: ${props => (props.color ? props.theme[props.color] : 'transparent')};
  border-bottom: 1px solid rgba(21, 43, 78, 0.06);

  &:last-child {
    border-bottom: none;
  }
`;

export const ColumnInsurance = styled(BaseColumn)`
  padding: ${props => (props.padding ? props.padding : '10px 14px')};
  background-color: ${props => (props.color ? props.theme[props.color] : 'transparent')};
  box-sizing: border-box;
`;

export const InsuranceTitle = styled.label`
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${props => props.theme.color_gray};
  margin: 0;
  line-height: 1.35;
`;
